import { Button, Icon } from '@material-ui/core';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function AddNewMeasurementToolbarButton(props) {
	return (
		<motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.2 } }}>
			<Button component={Link} to={() => `/measurement/${props.btn.type}/new`} className="whitespace-nowrap mx-8" variant="contained" color="secondary" startIcon={<Icon className="hidden sm:flex">add</Icon>}>
				Add
			</Button>
		</motion.div>
	);
}

export default AddNewMeasurementToolbarButton;
